import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=aaab4dde&scoped=true&"
import script from "./LocationList.vue?vue&type=script&lang=js&"
export * from "./LocationList.vue?vue&type=script&lang=js&"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=aaab4dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab4dde",
  null
  
)

export default component.exports